import { render, staticRenderFns } from "./pdfsinguia.vue?vue&type=template&id=15d49325"
import script from "./pdfsinguia.vue?vue&type=script&lang=js"
export * from "./pdfsinguia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports